import './AutocompleteWithChips.scss';

import { Autocomplete, Chip, Divider } from '@trackman/web-shared-components';

import { useAutoAnimate } from '@formkit/auto-animate/react';
import { useTranslation } from 'react-i18next';

type Props = {
  label: string;
  options: string[];
  getOptionLabel: (option: string) => string;
  noOptionsText?: string;
  disabled?: boolean;
  disableCloseOnSelect?: boolean;
  onDeleteChip?: (option: string) => void;
  onClear?: () => void;
} & (
  | {
      single?: false;
      selected: string[];
      setSelected: (newSelected: string[]) => void;
    }
  | {
      single: true;
      selected: string | undefined;
      setSelected: (newSelected: string) => void;
    }
);

const AutocompleteWithChips = ({
  label,
  options,
  selected,
  setSelected,
  getOptionLabel,
  noOptionsText,
  disabled = false,
  disableCloseOnSelect = false,
  onDeleteChip,
  onClear,
  single,
}: Props) => {
  const [parent] = useAutoAnimate();
  const { t } = useTranslation();

  return (
    <div className='autocomplete-container'>
      <div>
        <Autocomplete
          label={label}
          options={options}
          multiple={!single}
          value={selected}
          onChange={(e, newValue) => (single ? setSelected(newValue as string) : setSelected(newValue as string[]))} // TS was going crazy here
          renderTags={() => null}
          getOptionLabel={getOptionLabel}
          noOptionsText={noOptionsText}
          disabled={disabled}
          disableClearable
          disableCloseOnSelect={disableCloseOnSelect}
        />
        {!single && (
          <div className='autocomplete-chips' ref={parent} style={selected.length > 0 ? { marginTop: 16 } : {}}>
            {selected.map((option) => (
              <Chip
                label={getOptionLabel(option)}
                onDelete={() => {
                  setSelected(selected.filter((selectedOption) => selectedOption !== option));
                  onDeleteChip?.(option);
                }}
                color='#007AFF'
                key={label + option + getOptionLabel(option)}
              />
            ))}
            {selected.length > 0 && (
              <Chip
                label={t('Clear')}
                onClick={() => {
                  setSelected([]);
                  onClear?.();
                }}
                key={label + 'clear'}
              />
            )}
          </div>
        )}
      </div>
      <Divider />
    </div>
  );
};

export default AutocompleteWithChips;
